import { useTranslation } from 'react-i18next'

import { HeroStat } from '../stat/HeroStat'

type HeroStatListProps = {
  hours: string
  sessionDuration?: number
  bookingWindow?: number
}

export const HeroStatList = ({
  hours,
  sessionDuration,
  bookingWindow,
}: HeroStatListProps) => {
  const { t } = useTranslation('home')
  const stats = [
    {
      key: 'hours',
      value: hours,
      label: t('hero.stats.hours.label'),
    },
    {
      key: 'window',
      value:
        bookingWindow != null
          ? t('hero.stats.window.value', { days: bookingWindow })
          : '\u2014',
      label: t('hero.stats.window.label'),
    },
    {
      key: 'session',
      value:
        sessionDuration != null
          ? t('hero.stats.session.value', { minutes: sessionDuration })
          : '\u2014',
      label: t('hero.stats.session.label'),
    },
  ] as const

  return (
    <div className="hero-stat-list">
      {stats.map(stat => (
        <HeroStat key={stat.key} value={stat.value} label={stat.label} />
      ))}
    </div>
  )
}
